import BitesApi from '../index';
import { IShareWithIntegrationBody } from '../../../biteShare/biteShare.types';

export const shareWithIntegration = (body: IShareWithIntegrationBody) => BitesApi.post('/distribution/share/', body);
